import { useKeycloak } from "@react-keycloak/web";
import { Dropdown, Select } from "antd";
import Avatar from "antd/lib/avatar/avatar";
import i18n from "i18n/i18n";
import { useTranslation } from "react-i18next";
import flag_en from "../../assets/png/flag_en.png";
import flag_fr from "../../assets/png/flag_fr.png";

const { Option } = Select;

const MenuHeader = () => {
  const { keycloak } = useKeycloak();
  const { t } = useTranslation();

  const items = [{ label: t("logout"), key: "0" }];
  return (
    <div style={{ display: "flex", alignItems: "center", marginRight: "36px", gap: 32 }}>
      <Select
        size="middle"
        style={{ width: "70px", textAlign: "center" }}
        onChange={value => {
          i18n.changeLanguage(value);
          window.location.reload();
        }}
        value={i18n.language.split("-")[0]}
      >
        <Option key="fr" value="fr" style={{ textAlign: "center" }}>
          <img src={flag_fr} alt="fr" style={{ width: 20 }} />
        </Option>
        <Option key="en" value="en" style={{ textAlign: "center" }}>
          <img src={flag_en} alt="en" style={{ width: 20 }} />
        </Option>
      </Select>
      <Dropdown
        menu={{
          items,
          onClick: e => {
            if (e.key === "0") keycloak.logout();
          },
        }}
        trigger={["click"]}
      >
        <a>
          <Avatar style={{ verticalAlign: "middle", cursor: "pointer" }} size="large">
            {t("Home")}
          </Avatar>
        </a>
      </Dropdown>
    </div>
  );
};

export default MenuHeader;
